import { createAction } from '@poa/state';

// fetching
export const fetchDaemons = createAction('daemon/fetchDaemons', () => ({}));
export const fetchDaemonsSuccess = createAction(
  'daemon/fetchDaemonsSuccess',
  (data, syncStatus) => ({
    data,
    syncStatus
  })
);
export const fetchDaemonsFailed = createAction('daemon/fetchDaemonsFailed', () => ({}));

// commands
export const calculateStat = createAction('daemon/calculateStat', () => ({}));
export const syncDaemons = createAction('daemon/syncDaemons', () => ({}));

export const syncAccountsAll = createAction('daemon/syncAccountsAll', () => ({}));
export const syncMessagesAll = createAction('daemon/syncMessagesAll', () => ({}));
export const syncContactGiftsAll = createAction('daemon/syncContactGiftsAll', () => ({}));
export const syncStatsAll = createAction('daemon/syncStatsAll', () => ({}));

export const syncAccounts = createAction('daemon/syncAccounts', daemonId => ({ daemonId }));
export const syncStats = createAction('daemon/syncStats', daemonId => ({ daemonId }));
export const syncMessages = createAction('daemon/syncMessages', daemonId => ({ daemonId }));
export const sendHotList = createAction('daemon/sendHotList', daemonId => ({ daemonId }));
export const contactGiftsById = createAction('daemon/contactGiftsById', daemonId => ({ daemonId }));
export const syncDaemonsByTime = createAction('daemon/syncDaemonsByTime', (year, month) => ({
  year,
  month
}));
